import { Component, inject, OnInit, TemplateRef, ViewChild } from '@angular/core'
import {
  incomingSubscription,
  SubscriptionsService,
  SubscriptionStatus
} from '../../../../services/subscriptions'
import { Store } from '@ngrx/store'
import { selectUser } from '../../../../store/auth/auth.state'
import { BehaviorSubject, EMPTY, take } from 'rxjs'
import { CommonModule } from '@angular/common'
import { CapitalizePipe } from '../../../../pipes/capitalize.pipe'
import { NgbModal } from '@ng-bootstrap/ng-bootstrap'
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms'
import { ToastrService } from 'ngx-toastr'
import { Router } from '@angular/router'
import { eps } from '../../../../services/url.service'
import { HasPermissionDirective } from '../../../../directives/has-permission.directive'
import { loadSubscription } from '../../../../store/auth/auth.actions'

@Component({
  selector: 'app-basic',
  imports: [CommonModule, ReactiveFormsModule, CapitalizePipe, HasPermissionDirective],
  templateUrl: './basic.component.html',
  styleUrl: './basic.component.scss'
})
export class BasicComponent implements OnInit {
  @ViewChild('addLicenceModal') addLicenceModal!: TemplateRef<any>
  @ViewChild('removeLicencesModal') removeLicencesModal!: TemplateRef<any>
  store = inject(Store)
  router = inject(Router)
  modalService = inject(NgbModal)
  toastr = inject(ToastrService)
  subscriptions = inject(SubscriptionsService)
  eps = eps

  user = this.store.select(selectUser)
  customerSince!: Date
  SubscriptionStatus = SubscriptionStatus
  plan: incomingSubscription | null = null
  subscription$ = new BehaviorSubject<any>(EMPTY)
  subscriptionId = ''
  totalLicences = 0
  usedLicences = 0
  minimumLicences = 0
  fb = inject(FormBuilder)
  addForm!: FormGroup
  removeForm!: FormGroup

  ngOnInit() {
    this.user.pipe(take(1)).subscribe(usr => {
      if (usr) {
        //This subscription action is dispatched to update the subscription details in the store
        this.store.dispatch(loadSubscription({ businessId: usr.businessId }))
        this.subscriptions.getSubscriptions(usr.businessId).subscribe(res => {
          this.plan = res[0]
          this.customerSince = new Date(
            res.filter(p => p.parentSubscriptionId === null)[0].createdAt
          )
          this.subscriptionId = this.plan.id
          this.totalLicences = Number(this.plan?.licences?.[0]?.totalLicences ?? 0)
          this.usedLicences = Number(this.plan.licences?.[0]?.usedLicences ?? 0)
          this.subscription$.next(this.plan)
          this.minimumLicences = Number(this.plan?.minimumLicences ?? 1)
        })
      }
    })
  }

  initializeAddForm() {
    this.addForm = this.fb.group({
      addedLicences: [1, [Validators.required, Validators.min(1), Validators.max(99999)]]
    })
  }

  initializeRemoveForm() {
    // const removableLicences = this.totalLicences - this.usedLicences
    const maxRemovableLicences = this.totalLicences - this.minimumLicences
    this.removeForm = this.fb.group({
      removedLicences: [
        1,
        [Validators.required, Validators.min(1), Validators.max(maxRemovableLicences)]
      ]
    })
  }

  openAddModal() {
    this.initializeAddForm()
    this.modalService.open(this.addLicenceModal, {
      scrollable: false,
      centered: true,
      size: 'md'
    })
  }

  openRemoveModal() {
    this.initializeRemoveForm()
    // console.log('plan', this.plan)
    this.modalService.open(this.removeLicencesModal, {
      scrollable: false,
      centered: true,
      size: 'md'
    })
  }

  closeModal() {
    this.modalService.dismissAll()
  }

  addLicence() {
    if (this.addForm.invalid) {
      return
    }
    const { addedLicences } = this.addForm.value
    this.closeModal()
    this.router.navigate([eps.planAndBilling.previewAddLicencesPath, this.subscriptionId], {
      queryParams: {
        newTotalLicences: addedLicences + this.totalLicences
      }
    })
    //this.subscriptions
    //  .addLicences(this.subscriptionId, addedLicences + this.totalLicences)
    //  .pipe(take(1))
    //  .subscribe({
    //    next: updated => {
    //      //this.toastr.success('Licences added successfully!')
    //      this.plan = updated
    //      this.subscription$.next(updated)
    //      this.closeModal()
    //    },
    //    error: err => {
    //      this.toastr.error(err.error.message, err.error.error)
    //    }
    //  })
  }

  removeLicences() {
    if (this.removeForm.invalid) {
      return
    }
    const { removedLicences } = this.removeForm.value
    const newTotalLicences = this.totalLicences - removedLicences

    this.subscriptions
      .removeLicences(this.subscriptionId, newTotalLicences)
      .pipe(take(1))
      .subscribe({
        next: updated => {
          this.toastr.success(
            'Licence removal has been scheduled for your next billing date.',
            'Success'
          )
          this.plan = updated
          this.subscription$.next(updated)
          this.closeModal()
        },
        error: err => {
          this.toastr.error(err.error.message, err.error.error)
        }
      })
  }

  upgradePlan() {
    this.router.navigate([eps.planAndBilling.upgradePlanPath])
  }

  enforceLimit(event: any) {
    let value = Number(event.target.value)

    if (value > 99999) {
      event.target.value = 99999
      this.addForm.get('addedLicences')?.setValue(99999)
    }

    if (value < 0) {
      event.target.value = 0
      this.addForm.get('addedLicences')?.setValue(0)
    }
  }

  //renew plan gps
  renewPlan() {
    this.router.navigate([eps.planAndBilling.upgradePlanPath])
  }
}
